import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=48bb8c3e"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports